import { Textbox } from 'fabric';
import { autoFitTextbox } from '../../text';
import { AutoFitTextCreateConfig, AutoFitTextbox } from '../types';
import { AUTO_FIT_TEXT_FACTORY_DEFAULTS } from '../constants/defaults';

// Resize is panel-only: AutoFit constraints (width, maxHeight, fontSize range) belong to the
// metadata, not to Fabric's handle drag. Hiding all scale + rotate controls keeps the bbox in sync.
const RESIZE_CONTROLS_HIDDEN = {
  mt: false,
  mb: false,
  ml: false,
  mr: false,
  tl: false,
  tr: false,
  bl: false,
  br: false,
  mtr: false
};

/** Builds an AutoFitText (a Textbox with `autoFit` metadata) ready to add to the canvas. */
export function createAutoFitText(cfg: AutoFitTextCreateConfig): AutoFitTextbox {
  const D = AUTO_FIT_TEXT_FACTORY_DEFAULTS;
  const autoFit = cfg.autoFit ?? D.autoFit;

  const textbox = new Textbox(cfg.text ?? D.text, {
    originX: 'center',
    originY: 'top',
    left: cfg.left,
    top: cfg.top,
    width: cfg.width ?? D.width,
    fill: cfg.fill ?? D.fill,
    fontFamily: cfg.fontFamily ?? D.fontFamily,
    fontSize: autoFit.maxFontSize,
    fontWeight: cfg.fontWeight ?? D.fontWeight,
    fontStyle: cfg.fontStyle ?? D.fontStyle,
    textAlign: cfg.textAlign ?? D.textAlign,
    splitByGrapheme: cfg.splitByGrapheme ?? D.splitByGrapheme,
    lockScalingX: true,
    lockScalingY: true,
    lockRotation: true,
    objectCaching: false,
    selectable: true,
    evented: true
  }) as AutoFitTextbox;

  textbox.autoFit = { ...autoFit };
  textbox.setControlsVisibility(RESIZE_CONTROLS_HIDDEN);
  autoFitTextbox(textbox, textbox.autoFit);

  return textbox;
}
